module.exports = __webpack_public_path__ + "media/product/paper-cb6c8e66.jpg";